module.exports = __webpack_public_path__ + "img/connect-4.8bfd771f.svg";